<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">To the reader:</p>
<p class="block_"> </p>
<p class="block_3">Since before I could remember, the imagined shaped every aspect of my life. From the toys that came alive when given a name and a voice, to the world around me that melted into something more than initially met the eye. Although not all living creatures could tell their stories, I found solace and deeper understanding when I witnessed their context and gave them a voice. </p>
<p class="block_3"> </p>
<p class="block_3">This was not only where I had the best times, but the place that I have fought desperately to remain in throughout my life. </p>
<p class="block_3"> </p>
<p class="block_3">In short, I have always feared the day when enchantment, wonder and mystery would suffer genocide. Only to be revisited by the occasional, short-lived nostalgic moment. </p>
<p class="block_3"> </p>
<p class="block_3">Although flying dragons, monsters and other mythical beasts may forever exist in fantasy, let us do our very best in creating a compassionate, loving, and peaceful world. </p>
<p class="block_3"> </p>
<p class="block_3">One that won’t merely be found in the fiction section of our local bookstores but littered between the pages of our lives.</p>
<p class="block_4" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?92aff81a